import { EntityMetadata } from "@ngrx/data";
import { ListingServiceOffering } from "../interfaces/ListingServiceOffering";

export const listingServiceOfferingMetadata: Partial<EntityMetadata<ListingServiceOffering>> = {
	selectId: (serviceOffering: ListingServiceOffering) => serviceOffering.serviceOfferingName,
};
